import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchClaimNotes = createProvider(api.fetchClaimNotes).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Fetch claim notes aborted');
  } else {
    console.error('Fetch claim notes was failed:', error);
  }
  throw error;
});
